// NotificationPanel.js
import React from 'react';
import './Panel.css';
import defaultUserProfile from "../../assets/defaultUserProfile.jpeg";


const NotificationPanel = ({ onClose, notifications  }) => {


  return (
    <div className="modal-panel">
      <div className="panel-header">
        <h2>Notifications</h2>
        <button onClick={onClose}>✖</button>
      </div>
      <div className="panel-body">
        {notifications.length === 0 ? (
          <p className="empty">No new notifications 🚀</p>
        ) : (
          notifications.map((notif) => (
            <div key={notif.id} className="notifItem">

              <img
                className="notifUserImg"
                src={
                  notif.data.user_avatar
                    ? `https://dashboard.tiktaka.com/${notif.data.user_avatar}`
                    : defaultUserProfile
                }            
                  alt="profile"
              />
              <div className="notifBody">
                <div>
                  <span className="notifUsername">{notif.data.user_name}</span>{" "}
                  <span className="notifText">{notif.data.message}</span>
                </div>
                <div className="notifTime">
                  <span className="notifSubText">{notif.data.sub_message}</span>
                  <span className="notifTimeText">
                    {new Date(notif.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}
                  </span>
                </div>
              </div>
                              



            </div>
          )))}

      </div>
      <div style={{ textAlign:'right' }}>
          Read All
      </div>
      
    </div>
  );
};

export default NotificationPanel;
